import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';
import type { IRoute } from '..';

const IdentifiersPage = lazy(() => import('@cobliteam/identifiers/src/pages/IdentifiersPage'));

const routes: IRoute[] = [
  {
    path: Location.IDENTIFIERS,
    component: IdentifiersPage,
    exact: true,
  },
];

export default routes;
